import { Close, ArrowLeft } from '@gympass/yoga-icons';

import * as S from './style';

import { DrawerProps } from './types';

const Drawer: React.FC<DrawerProps> = ({
  openDrawer,
  onCloseDrawer,
  onSetPage,
  showArrowLeftIcon,
  children,
}) => {
  return (
    <S.DrawerContainer
      isOpen={openDrawer}
      data-testid="DrawerContainerCloseIcon"
    >
      <S.DrawerHeader isShowArrowLeftIcon={showArrowLeftIcon}>
        {showArrowLeftIcon && (
          <S.ArrowLeftIcon
            data-testid="DrawerHeaderArrowLeftIcon"
            onClick={() => onSetPage?.(1)}
            icon={ArrowLeft}
            inverted
          />
        )}

        <S.CloseIcon
          data-testid="DrawerHeaderCloseIcon"
          onClick={onCloseDrawer}
          icon={Close}
          inverted
        />
      </S.DrawerHeader>

      <S.DrawerContent>{children}</S.DrawerContent>
    </S.DrawerContainer>
  );
};

export default Drawer;
